import { v4 as uuid } from 'uuid';

import { MESSAGES } from '../../../constants';

export interface ISkillSuccessMessage {
  readonly id: string;
  readonly text?: string;
  readonly type: MESSAGES.SKILL_SUCCESS_MESSAGE;
  readonly nodeId: string;
  readonly rm: boolean;
  readonly role?: string;
}

export const createSkillSuccessMessage = (data: {
  id?: string;
  _id?: string;
  text?: string;
  nodeId?: string;
  rm?: boolean;
  role?: string;
}): ISkillSuccessMessage => ({
  id: data.id ?? data._id ?? uuid(),
  text: data.text,
  type: MESSAGES.SKILL_SUCCESS_MESSAGE,
  nodeId: data.nodeId ?? '',
  rm: Boolean(data.rm),
  role: data.role,
});
